import { number, object, SchemaOf, string } from "yup";
import { requiredFieldValidationMessage } from "../../Forms/ValidationMessages";
import { yupGsdbValidation } from "../../Forms/yupGsdbValidation";
import { nameOf } from "../../Utils/nameOf";
import { Edc } from "../Edc";

export const edcSchema: SchemaOf<Edc> = object()
  .shape({
    Gsdb: yupGsdbValidation(nameOf<Edc>("Gsdb")),
    CountryId: number().notOneOf([0], requiredFieldValidationMessage("Country")).required(),
    Name: string().required(requiredFieldValidationMessage("Name")),
    City: string().required(requiredFieldValidationMessage("City")),
    ZipCode: string().required(requiredFieldValidationMessage("Postcode")),
    ZipArea: string().required(requiredFieldValidationMessage("Postcode Area")),
  })
  .required();
